import { useEffect } from 'react';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import { FFFErrorBoundary } from '@fff-web/fff-ui-shared';
import './App.css';
import AboutUs from './pages/AboutUs';
import Careers from './pages/Careers';
import DownloadApp from './pages/DownloadApp';
import Inquiries from './pages/Inquiries';
import JobPost from './pages/JobPost';
import NotFoundError from './pages/NotFoundError';
import Dashboard from './pages/Referrals/Dashboard';
import Invite from './pages/Referrals/Invite';
import { getUserInfo } from './services';
import { loadTalkable } from './utils/loadTalkable';

function App() {
  useEffect(() => {
    getUserInfo()
      .then((responseJson) => {
        loadTalkable(responseJson);
      })
      .catch((error) => {
        console.warn('Error loading Talkable', error);
        console.error(error);
        loadTalkable();
      });
  }, []);

  return (
    <FFFErrorBoundary>
      <div className="App">
        <Router>
          <Switch>
            <Route path="/inquiries" component={Inquiries} />
            <Route path="/s/inquiries" component={Inquiries} />
            <Route path="/invite" component={Invite} />
            <Route path="/s/invite" component={Invite} />
            <Route path="/my-account/referral-dashboard" component={Dashboard} />
            <Route path="/about-us" component={AboutUs} />
            <Route path="/s/about-us" component={AboutUs} />
            <Route path="/careers" component={Careers} />
            <Route path="/job-post" component={JobPost} />
            <Route path="/mobile-app" component={DownloadApp} />
            <Route path="/s/mobile-app" component={DownloadApp} />
            <Route component={NotFoundError} />
          </Switch>
        </Router>
      </div>
    </FFFErrorBoundary>
  );
}

export default App;
